import React from "react";
import ActionsPopup from "../ActionsPopup";
import schema from "../ActionsPopup/agriculture_actions";
import cellGenerator from "./columnUtils";

const agriculture_columns = (isSubaccount) => [
  {
    Header: "Employer Name",
    accessor: "AgricultureFormData.new_profile_agriculture_emp_name",
    Cell: (props) => cellGenerator(props),
    minWidth: 235,
    maxWidth: 245,
  },
  {
    Header: "Worksite Address",
    accessor: "AgricultureFormData.new_profile_agriculture_worksite_address",
    Cell: (props) => cellGenerator(props),
    minWidth: 300,
  },
  {
    Header: "City",
    accessor: "AgricultureFormData.new_profile_agriculture_city",
    Cell: (props) => cellGenerator(props),
    minWidth: 160,
    maxWidth: 170,
  },
  {
    Header: "State",
    accessor: "AgricultureFormData.new_profile_agriculture_state",
    Cell: (props) => cellGenerator(props),
    fixedWidth: 220,
  },
  {
    Header: "County",
    accessor: "AgricultureFormData.new_profile_agriculture_county.label",
    Cell: (props) => cellGenerator(props),
    minWidth: 250,
    maxWidth: 260,
  },
  {
    Header: "Postal Code",
    accessor: "AgricultureFormData.new_profile_agriculture_zip",
    Cell: (props) => cellGenerator(props),
    minWidth: 135,
    maxWidth: 145,
  },
  {
    Header: "Additional Place of Employment Information",
    accessor: "AgricultureFormData.new_profile_agriculture_add_emp_info",
    Cell: (props) => cellGenerator(props),
    minWidth: 400,
  },
  {
    Header: "Profile Name",
    accessor: "AgricultureFormData.new_profile_agriculture_profile_name",
    Cell: (props) => cellGenerator(props),
    minWidth: 200,
    maxWidth: 250,
  },
  {
    id: "actions",
    Header: "Actions",
    accessor: (d) => d,
    fixedWidth: 130,
    disableSortBy: true,
    isButton: true, // removes padding and positioning
    Cell: ({ row: { original } }) => (
      <ActionsPopup
        actionsPopupSchema={schema("agriculture", isSubaccount)}
        id={original.id}
      />
    ),
  },
];

export default agriculture_columns;
